import { GatsbyImage } from 'gatsby-plugin-image';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import React from 'react';

import * as styles from './Testimonial.module.css';

const Testimonial = ({ logo, logoClass, body, attribution, pClassName = '' }) => {
  let image = <img src={get(logo, 'file.url')} alt={logo.title} />;
  if (logo.file.contentType !== 'image/svg+xml' && !!logo.gatsbyImageData) {
    image = <GatsbyImage alt={logo.title} image={logo.gatsbyImageData} />;
  }
  return (
    <div className={styles.container}>
      <div className={[styles.logo, logoClass].join(' ')}>{image}</div>
      <div className={styles.copy}>
        <p className={pClassName}>{body}</p>
        {attribution && (
          <p className={styles.attribution}>
            <span>_</span>
            {attribution}
          </p>
        )}
      </div>
    </div>
  );
};

Testimonial.propTypes = {
  logo: PropTypes.object.isRequired,
  body: PropTypes.string.isRequired,
  logoClass: PropTypes.string,
  pClassName: PropTypes.string,
};

export default Testimonial;
